<template>
  <app-window
    :value="dialog"
    fullscreen
  >
    <template v-slot:body>
      <historico-responsabilidade-list
        :responsabilidade="responsabilidade"
        :etapa="etapa"
      />
    </template>
  </app-window>
</template>

<script>
import HistoricoResponsabilidadeList from '@/components/mapeamento/HistoricoResponsabilidadeList';
import AppWindow from '@/components/core/AppWindow';

export default {
  name: 'HistoricoResponsabilidade',

  components: { HistoricoResponsabilidadeList, AppWindow },

  props: {
    dialog: {
      type: Object,
      default: () => ({}),
    },
    responsabilidade: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    etapa: {
      type: String,
      required: true,
    },
  },
};
</script>
